import React, { useState } from "react";
import { Col,Row } from "reactstrap";
import { handleAudioTextInput } from "../../components/edit_quiz_helper/EditQuizHelper";
export const ListeningContent = ({
  data,
  IsGenerating,
}) => {
  const [Contentedit, setContentedit] = useState(false);

  return (
    <Col>
      <div
        class="d-flex flex-column"
        style={{ minHeight: "10vh" }}
      >
        <>
        <Row>
            <Col md className={`py-2 col-12 d-flex align-items-center`}>
                <div
                spellcheck="false"
                data-gramm="false"
                class="col-10 d-flex justify-content-start"
                contentEditable={Contentedit}
                onInput={handleAudioTextInput({
                    type: "header",
                    quizdata: data,
                })}
                >
                <h1 class="fs-6 fw-bold mb-0 pe-3">
                    {data?.prompt_content?.content}
                    {data?.prompt_content?.isMounted ? (
                    ""
                    ) : (
                    <span className="blinking-cursor"></span>
                    )}
                </h1>
                </div>
                <div class="col-2 d-flex justify-content-end">
                {Contentedit ? (
                    <button class="btn btn-darkblue px-3 py-0 no-download" type="button" onClick={() => {setContentedit(false);}}>
                        Save
                    </button>
                ) : IsGenerating ? (
                    <button class="btn btn-darkblue px-3 py-0 no-download" type="button" disabled>
                        Edit
                    </button>
                ) : (
                    <button class="btn btn-darkblue px-3 py-0 no-download" type="button" onClick={() => {setContentedit(true);}}>
                        Edit
                    </button>
                )}
                </div>
            </Col>
        </Row>
        </>
        <div className="pt-3">
        {data?.audio_text && (
            <div
                className=""
                contentEditable={Contentedit}
                spellcheck="false"
                data-gramm="false"
                onInput={handleAudioTextInput({
                type: "audio_text",
                quizdata: data,
                })}
                dangerouslySetInnerHTML={{
                    __html: `${data?.audio_text?.replace(/\[\[.*?\]\]\.\s*/g, '').replace(/\[\[.*?\]\]\s*/g, '')}
                            ${IsGenerating ? (`<span class="blinking-cursor"></span>`): ""}`,
                }}
            />
        )}
        </div>
      </div>
    </Col>
  );
};
